import TextLink from '@narvar/nth-bit-text-link';
import { RetailerTheme } from '@narvar/nth-hook-loma';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import React, { CSSProperties, FC, useContext } from 'react';
import CustomComponentContext from '../../CustomComponentContext';
import { useTranslator } from '../utils/translator';

interface IProps {
  onClick: () => void;
}

const RescheduleLink: FC<IProps> = (props) => {
  const { onClick } = props;
  const { track } = useContext(CustomComponentContext);

  const { t } = useTranslator();
  const scheduleDeliveryRescheduleDeliveryLink = t('Reschedule Delivery');

  const { buttonsPrimaryDefault, buttonsPrimaryHover } = useTheme() as {
    [key in keyof RetailerTheme]: CSSProperties;
  };

  const handleClick = () => {
    track({
      eventType: 'click',
      clickSubType: 'scheduledDeliveryRescheduleLinkClick',
    });

    onClick();
  };

  return (
    <TextLink
      onClick={handleClick}
      linkStyle={{
        sDefault: {
          color: buttonsPrimaryDefault?.backgroundColor,
          fontWeight: 'bold',
          textDecoration: 'none',
        },
        sHover: {
          color: buttonsPrimaryHover?.backgroundColor,
          textDecoration: 'none',
        },
      }}
    >
      {scheduleDeliveryRescheduleDeliveryLink}
    </TextLink>
  );
};

export default withThemeProvider(RescheduleLink, {
  themeTokens: ['buttonsPrimaryDefault', 'buttonsPrimaryHover'],
});
